module.exports = __webpack_public_path__ + "img/BE.a7f64464.png";